import { useSelector } from 'react-redux';
import { useIntl, defineMessages } from 'react-intl';
import { Loader } from 'semantic-ui-react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { categorieView } from './utils';

const Struttura = (props) => {
  const intl = useIntl();

  const {
    tipo,
    struttura,
    categoria,
    comune,
    indirizzo,
    telefono,
    email,
    cin,
    www,
  } = props;
  return (
    <div className="struttura">
      {tipo && <div>{tipo}</div>}
      {/* <div className="nome-container"> */}
      {struttura && (
        <div className="nome">
          <span>{struttura}</span>{' '}
          <span className="categoria">
            {categorieView[categoria] ? categorieView[categoria] : ''}
          </span>
        </div>
      )}

      {comune && <div>{comune}</div>}
      {indirizzo && <div className="address">{indirizzo}</div>}
      {telefono && (
        <div>
          <span>{intl.formatMessage(messages.struttura_telefono)}</span>{' '}
          <span>
            <a href={`tel:${telefono}`}>{telefono}</a>
          </span>
        </div>
      )}
      {email && (
        <div>
          <a href={`mailto:${email}`}>{email}</a>
        </div>
      )}
      {www && (
        <div>
          <UniversalLink href={www}>{www}</UniversalLink>
        </div>
      )}
      {cin && (
        <div>
          <span>CIN:</span> <span>{cin}</span>
        </div>
      )}
    </div>
  );
};

const ElencoStrutture = () => {
  const intl = useIntl();
  const struttureData = useSelector((state) => state.ross1000strutture);
  const strutture = struttureData?.result;
  const loadingStutture = struttureData?.loading;
  const error = struttureData?.error;

  return (
    <div className="elenco-strutture">
      {loadingStutture && (
        <div className="loader-container">
          <Loader active size="large" />
        </div>
      )}

      {strutture &&
        !loadingStutture &&
        strutture?.length > 0 &&
        strutture.map((struttura, index) => (
          <Struttura key={index} {...struttura} />
        ))}

      {error && (
        <div className="error-message">
          {intl.formatMessage(messages.error_message)}
        </div>
      )}

      {!error && (!strutture || strutture.length === 0) && (
        <div className="no-results">
          {intl.formatMessage(messages.no_results)}
        </div>
      )}
    </div>
  );
};

export default ElencoStrutture;

const messages = defineMessages({
  struttura_telefono: {
    id: 'struttura_telefono',
    defaultMessage: 'Telefono',
  },
  error_message: {
    id: 'error_message',
    defaultMessage: 'Si è verificato un errore',
  },
  no_results: {
    id: 'no_results',
    defaultMessage:
      'Non sono presenti strutture che corrispondano ai filtri impostati',
  },
});
